import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

import { DatepickerComponent } from './datepicker.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    NgbDatepickerModule
  ],
  declarations: [
    DatepickerComponent
  ],
  exports: [
    DatepickerComponent
  ]
})
export class DatepickerModule {
}
